import ApiService from './ApiService';
import FirewallRule from '../types/FirewallRule';
import { API_FIREWALL } from '../core/CcxEnv';

// constants
const API_URL = API_FIREWALL;

export type AddRuleProps = {
    uuid: string;
    source: string;
    description?: string;
};

export type DeleteRuleProps = {
    rule: FirewallRule;
    uuid: string;
};

export default class FirewallService extends ApiService {
    /**
     * Get list of all firewall rules.
     * @param {string} uuid
     */
    static async getAllRules(uuid: string): Promise<FirewallRule[]> {
        const response = await this.request('GET', `firewalls/${uuid}`);
        return response.map((r: any) => new FirewallRule(r));
    }

    /**
     * Add a Firewall rule
     * @param {AddRuleProps} props
     */
    static async addRule({
        uuid,
        source,
        description,
    }: AddRuleProps): Promise<any> {
        const postData = {
            data: {
                source,
                description: description,
            },
        };
        return await this.request('POST', `firewall/${uuid}`, postData);
    }

    /**
     * Delete a Firewall rule
     * @param {FirewallRule} rule
     * @param {string} uuid
     */
    static async deleteRule({ rule, uuid }: DeleteRuleProps): Promise<any> {
        const requestData = {
            data: {
                description: rule?.description,
                from_port: rule?.fromPort,
                protocol: rule?.protocol,
                security_group_id: rule?.securityGroupId,
                security_group_rule_id: rule?.securityGroupRuleId,
                source: rule?.source,
                to_port: rule?.toPort,
            },
        };
        return await this.request('DELETE', `firewall/${uuid}`, requestData);
    }

    protected static getApiUrl() {
        return API_URL;
    }
}
